module.exports = __webpack_public_path__ + "img/557-42dfb3.png";